import React from 'react'
import PropTypes from 'prop-types'
import Hyperlink from '../../../HyperLink'
import classNames from 'classnames'

const Author = ({ fullName, url, className, showPrefixText = true }) => (
  <Hyperlink
    href={url}
    childrenClassNames={classNames('text-blue-560', className)}
    data-testid="author"
    clickTracking={false}
  >
    {showPrefixText ? `BY ${fullName}` : fullName}
  </Hyperlink>
)

Author.propTypes = {
  fullName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
}

Author.defaultProps = {
  className: 'text-base',
}

export default Author
